export const URGENCY_MESSAGING_GET_REQUEST = 'URGENCY_MESSAGING_GET_REQUEST';
export const URGENCY_MESSAGING_GET_SUCCESS = 'URGENCY_MESSAGING_GET_SUCCESS';
